export const NOT_VALIDATED = 'NOT_VALIDATED';
export const IS_VALID = 'IS_VALID';
export const IS_INVALID = 'IS_INVALID';
